import { useEffect, useState } from "react";
import React from "react";
import NotFound from "../notfound/notfound";
import Element from "../element/element";
import { getFullPageItem, getTicker } from "../api/core";
import Ticker from "../Ticker/ticker";
import { getAWSUrl } from "../api/core";
import Head from "../head/head";
import CarouselContentLoader from "../loader/contentLoader";
import InfiniteScroll from "react-infinite-scroll-component";
import Listloader from "../loader/listloader";
const NormalPage = (props) => {
  const [page, setPage] = useState([]);
  const [loading, isLoading] = useState(true);
  const [error, SetError] = useState(false);
  const [web, SetWeb] = useState(true);
  const [tickStatus, SetTickStatus] = useState("");
  const [tick, setTick] = useState([]);
  const [itemNum, setItemNum] = useState(0);
  const [hasHigh, sethasHigh] = useState(true);
  const [pageItem, setPageItem] = useState([]);

  useEffect(() => {
    const PageDetail = async (app, id) => {
      /* eslint-disable no-unused-vars */
      const result = await getFullPageItem(app, id, 0, 6).then(
        (result) => {
          setPage(result.data);
          setPageItem(result.data.items);
          setItemNum(result.data.items.length);
          SetWeb(result.data.devices[0].itemVisibility);
          getTickerDetail(app, id);
        },
        (error) => {
          SetError(true);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    const getTickerDetail = async (app, id) => {
      /* eslint-disable no-unused-vars */
      const result = await getTicker(app, id).then(
        (result) => {
          setTick(result.data);
          SetTickStatus(result.status);
        },
        (error) => {}
      );
      /* eslint-disable no-unused-vars */
    };

    PageDetail(props.match.params.AppId, props.match.params.Id);
    isLoading(false);
  }, [props.match.params.Id, props.match.params.AppId]);

  const fetchData = async () => {
    const length = page.items.length;

    try {
      const appl = await getFullPageItem(
        props.match.params.AppId,
        props.match.params.Id,
        length,
        length + 6
      );

      const pages = appl.data.items;

      const imageCount = appl.data.itemCount;

      setItemNum(imageCount);
      const newArray = [...pageItem, ...pages];

      setPageItem(newArray);
      setItemNum(imageCount);

      if (itemNum === pageItem.length) {
        sethasHigh(false);
      }
    } catch (error) {}
  };

  if (!loading && !error && web && page.length !== 0) {
    return (
      <div style={{ minHeight: "500px" }}>
        <Head
          title={page.displayName}
          quote={page.displayName}
          description={page.description}
          image={
            page.bannerImage != null
              ? getAWSUrl() + page.bannerImage.imagekey
              : ""
          }
        ></Head>
        <InfiniteScroll
          dataLength={itemNum}
          hasMore={hasHigh}
          loader={<Listloader></Listloader>}
          next={fetchData}
        >
          {pageItem.length > 0
            ? pageItem.map((elem, index) =>
                index === 0 &&
                (elem.itemid.elementType === "multiCarousel" ||
                  elem.itemid.elementType === "newsCarousel" ||
                  elem.itemid.elementType === "movieCarousel") ? (
                  <div key={index} style={{ paddingTop: "70px" }}>
                    {" "}
                    <Element
                      information={elem.itemid}
                      type={elem.itemid.elementType}
                      id={elem.itemid._id}
                      name={elem.itemid.urlName}
                      index={index}
                      {...props}
                    ></Element>
                  </div>
                ) : index === 0 && elem.itemid.elementType === "3dCarousel" ? (
                  <div key={index} style={{ paddingBottom: "40px" }}>
                    {" "}
                    <Element
                      information={elem.itemid}
                      type={elem.itemid.elementType}
                      id={elem.itemid._id}
                      name={elem.itemid.urlName}
                      index={index}
                      {...props}
                    ></Element>
                  </div>
                ) : index === 0 ? (
                  <div key={index} style={{ paddingTop: "100px" }}>
                    {" "}
                    <Element
                      information={elem.itemid}
                      type={elem.itemid.elementType}
                      id={elem.itemid._id}
                      ids={elem.itemid._id}
                      name={elem.itemid.urlName}
                      index={index}
                      {...props}
                    ></Element>
                  </div>
                ) : (
                  <div key={index}>
                    {" "}
                    <Element
                      information={elem.itemid}
                      type={elem.itemid.elementType}
                      id={elem.itemid._id}
                      ids={elem.itemid._id}
                      name={elem.itemid.urlName}
                      index={index}
                      {...props}
                    ></Element>
                  </div>
                )
              )
            : ""}
        </InfiniteScroll>
        {tickStatus.toString() === "200" && tick != null ? (
          <Ticker id={"ticker" + 20} tickData={tick}></Ticker>
        ) : (
          ""
        )}
      </div>
    );
  } else {
    if (!web) {
      return (
        <div style={{ minHeight: "500px" }}>
          <NotFound
            code={"Hidden Page"}
            message={"This Page is Hidden in thw Website"}
          ></NotFound>
        </div>
      );
    } else if (loading) {
      return (
        <div style={{ minHeight: "400px" }}>
          <CarouselContentLoader />
        </div>
      );
    } else {
      return <div style={{ minHeight: "500px" }}></div>;
    }
  }
};

export default NormalPage;
